"use client";

import { useEffect } from "react";

import * as Sentry from "@sentry/nextjs";

import { Button, Link } from "@marketing-sites/ui/primitives";

export default function NewBlogError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <section
      data-analytics-region="New Blog Error"
      data-analytics-id="sec_new_blog_error"
      className="flex min-h-[70vh] flex-col items-center justify-center gap-6 bg-white px-6 text-center"
    >
      <h1 className="text-heading-4 text-balance">Something went wrong.</h1>
      <p className="text-body-xl text-balance">
        We couldn&rsquo;t load this page. Try again, or head back to the{" "}
        <Link
          analyticsId="link_new_blog_error_homepage"
          href="/blog"
          className="text-inline-link"
        >
          blog homepage
        </Link>
        .
      </p>
      <Button analyticsId="btn_new_blog_error_retry" onClick={reset}>
        Try again
      </Button>
    </section>
  );
}
